export enum PromotionItemRuleDataType {
    PartNumber = "PartNumber",
    PicCode = "PicCode",
    ItemClass = "ItemClass",
    GLTable = "GLTable",
}
